module.exports = __webpack_public_path__ + "img/vip.cec2ceb1.svg";